import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { CommentSection } from "./CommentSection";

function View(props) {
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const [storeStatus, setStoreStatus] = useState("");
  const [rsmStatus, setRsmStatus] = useState("");
  const [role, setRole] = useState([]);

  const [technicalServices, setTechnicalServices] = useState([
    {
      title: "Sampling",
      name: "sampling",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Pull out Test",
      name: "pull_out_test",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Supervision",
      name: "supervision",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Complaint",
      name: "complaint",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Training at Site",
      name: "training_at_site",
      check: false,
      disabled: true,
      detail: "",
    },
    {
      title: "Other Technical Support",
      name: "other_technical_support",
      check: false,
      disabled: true,
      detail: "",
    },
  ]);

  const [formData, setFormData] = useState({
    salePersonName: "",
    designation: "",
    location: "",
    state: "",
    siteDetail: "",
    products: [],
    visitDate: "",
    technicalMember: "",
    files: [],
  });
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isValidFile, setIsValidFile] = useState(true); // For file validation
  const [loading, setLoading] = useState(false); // For loading spinner

  const [validated, setValidated] = useState(false);
  const [storeNote, setStoreNote] = useState("");
  const [storeErrors, setStoreErrors] = useState({});
  const [rsmNote, setRsmNote] = useState("");
  const [rsmErrors, setRsmErrors] = useState({});
  const [technicalErrors, setTechnicalErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [ctoStatus, setCtoStatus] = useState("");
  const [ctoNote, setCtoNote] = useState("");
  const [ctoErrors, setCtoErrors] = useState({});
  const [attachErrors, setAttachErrors] = useState("");

  const [finalCtoStatus, setFinalCtoStatus] = useState("");
  const [finalCtoNote, setFinalCtoNote] = useState("");
  const [finalCtoErrors, setFinalCtoErrors] = useState({});

  const [ceoStatus, setCeoStatus] = useState("");
  const [ceoNote, setCeoNote] = useState("");
  const [ceoErrors, setCeoErrors] = useState({});

  const [ttmStatus, setTtmStatus] = useState("");
  const [ttmNote, setTtmNote] = useState("");
  const [ttmErrors, setTtmErrors] = useState({});

  const [productValid, setProductValid] = useState(false);
  const [isTechnicalServiceSelected, setIsTechnicalServiceSelected] =
    useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }

    setFormData({
      ...formData,
      salePersonName: `${userProfile.firstName} ${userProfile.middleName} ${userProfile.lastName}`,
      designation: userProfile?.user_role[0].roleName,
    });
  }, [userProfile]);

  useEffect(() => {
    getRoleList();
  }, []);

  // Handle file input change
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    validateFiles(files);
  };

  // Handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  // Handle drag enter
  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDraggingOver(true);
  };

  // Handle drag leave
  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
  };

  // Handle file drop
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingOver(false);

    const files = Array.from(e.dataTransfer.files);

    validateFiles(files);
  };

  const validateFiles = (files) => {
    setIsValidFile(true);
    setAttachErrors("");
    setFormData((prevFormData) => {
      const updatedFiles = [...(prevFormData.files || []), ...files];

      return {
        ...prevFormData,
        files: updatedFiles,
      };
    });
  };

  // Handle file deletion
  const handleDeleteFile = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prevFormData) => {
          const updatedFiles = [...prevFormData.files];
          updatedFiles.splice(index, 1); // Remove file at index
          return {
            ...prevFormData,
            files: updatedFiles,
          };
        });
      }
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const isTechnicalServiceValid = technicalServices.filter(
      (item) => item.check === true
    ).length;

    let error = 0;
    setProductValid(false);
    setIsTechnicalServiceSelected(false);
    if (formData.products.length === 0) {
      setProductValid(true);
      error++;
    }
    if (isTechnicalServiceValid === 0) {
      setIsTechnicalServiceSelected(true);
      error++;
    }

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      error++;
    }

    if (!error) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      setIsSubmit(false);
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
      }
      bodyFormData.append("sales_person_name", formData.salePersonName);
      bodyFormData.append("designation", formData.designation);
      bodyFormData.append("location", formData.location);
      bodyFormData.append("state", formData.state);
      bodyFormData.append("site_details", formData.siteDetail);
      bodyFormData.append(
        "visit_date",
        moment(formData.visitDate).format("YYYY-MM-DD")
      );
      formData.products.forEach((product, index) => {
        bodyFormData.append(`products[${index}]`, product.id);
      });
      const filteredServices = technicalServices.filter(
        (service) => service.detail !== ""
      );

      filteredServices.forEach((service, index) => {
        bodyFormData.append(`technical_service_nm[${index}]`, service.name);
        bodyFormData.append(
          `technical_service_details[${index}]`,
          service.detail
        );
      });

      utils
        .callAPI("post", "/sales/save_request", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const getRoleList = () => {
    utils
      .callAPI("get", `/sales/getTechnical_member_lists`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setRole(res);
        } else {
          setRole([]);
        }
      })
      .catch((err) => {
        setRole([]);
      });
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      setFormData({
        salePersonName: props?.rowData?.sales_person_name || "",
        siteDetail: props?.rowData?.site_details || "",
        designation: props?.rowData?.designation || "",
        state: props?.rowData?.state || "",
        location: props?.rowData?.location || "",
        visitDate: props?.rowData?.visit_date || "",

        products: props?.rowData?.products || [],
      });

      const apiData = props?.rowData?.technical_service || [];

      setTechnicalServices((prevServices) => {
        return prevServices.map((service) => {
          const matchingService = apiData.find(
            (apiItem) => apiItem.technical_service_nm === service.name
          );

          if (matchingService) {
            return {
              ...service,
              detail: matchingService.technical_service_details,
              check: true,
              disabled: false,
            };
          }
          return service;
        });
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const rsmValidFun = () => {
    const newErrors = {};
    if (!rsmNote) {
      newErrors.rsmNote = "Note is required";
    }
    return newErrors;
  };

  const handleStoreInputChange = (e) => {
    const { name, value } = e.target;

    // Remove leading spaces only (leave trailing spaces intact)
    const cleanedValue = value.replace(/^\s+/, "");

    // Update corresponding state based on the input name
    if (name === "storeNote") {
      setStoreNote(cleanedValue);
      setStoreErrors((prevErrors) => ({
        ...prevErrors,
        storeNote: cleanedValue ? "" : prevErrors.storeNote,
      }));
    }

    if (name === "rsmNote") {
      setRsmNote(cleanedValue);
      setRsmErrors((prevErrors) => ({
        ...prevErrors,
        rsmNote: cleanedValue ? "" : prevErrors.rsmNote,
      }));
    }

    if (name === "ctoNote") {
      setCtoNote(cleanedValue);
      setCtoErrors((prevErrors) => ({
        ...prevErrors,
        ctoNote: cleanedValue ? "" : prevErrors.ctoNote,
      }));
    }

    if (name === "ttmNote") {
      setTtmNote(cleanedValue);
      setTtmErrors((prevErrors) => ({
        ...prevErrors,
        ttmNote: cleanedValue ? "" : prevErrors.ttmNote,
      }));
    }

    if (name === "finalCtoNote") {
      setFinalCtoNote(cleanedValue);
      setFinalCtoErrors((prevErrors) => ({
        ...prevErrors,
        finalCtoNote: cleanedValue ? "" : prevErrors.finalCtoNote,
      }));
    }

    if (name === "ceoNote") {
      setCeoNote(cleanedValue);
      setCeoErrors((prevErrors) => ({
        ...prevErrors,
        ceoNote: cleanedValue ? "" : prevErrors.ceoNote,
      }));
    }
  };

  const handleStoreAccept = () => {
    const validationErrors = techValidate();
    setTechnicalErrors(validationErrors);

    if (
      formData.technicalMember !== "" &&
      formData.technicalMember !== undefined
    )
      setStoreStatus("1");
  };

  const handleRsmAccept = () => {
    setRsmStatus("1");
  };

  const handleRsmReject = (e) => {
    const validationErrors = rsmValidate();

    setRsmErrors(validationErrors);
    if (rsmNote !== "") setRsmStatus("2");
  };
  const rsmValidate = () => {
    const newErrors = {};
    if (!rsmNote) {
      newErrors.rsmNote = "Note is required";
    }
    return newErrors;
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (rsmStatus === "1" || rsmStatus === "2") {
      if (rsmStatus === "1") {
        sendRsmStatus("accept");
      } else if (rsmStatus === "2") {
        sendRsmStatus("reject");
      }
    }
  }, [rsmStatus]);

  const sendRsmStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (rsmStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", rsmStatus);
      bodyFormData.append("remarks", rsmNote);

      utils
        .callAPI("post", `/sales/ticket_support_rsm`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                rsmStatus === "1"
                  ? "Ticket has been accepted."
                  : "Ticket has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const handleCtoAccept = () => {
    const validationErrors = techValidate();
    setTechnicalErrors(validationErrors);

    if (
      formData.technicalMember !== "" &&
      formData.technicalMember !== undefined
    )
      setCtoStatus("1");
  };

  const handleFinalCtoAccept = () => {
    setFinalCtoStatus("1");
  };

  const handleFinalCtoReject = (e) => {
    const validationErrors = finalCtoValidate();

    setFinalCtoErrors(validationErrors);
    if (finalCtoNote !== "") setFinalCtoStatus("2");
  };
  const finalCtoValidate = () => {
    const newErrors = {};
    if (!finalCtoNote) {
      newErrors.finalCtoNote = "Note is required";
    }
    return newErrors;
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (finalCtoStatus === "1" || finalCtoStatus === "2") {
      if (finalCtoStatus === "1") {
        sendFinalCtoStatus("accept");
      } else if (finalCtoStatus === "2") {
        sendFinalCtoStatus("reject");
      }
    }
  }, [finalCtoStatus]);

  const sendFinalCtoStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (finalCtoStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", finalCtoStatus);
      bodyFormData.append("remarks", finalCtoNote);

      utils
        .callAPI("post", `/sales/ticket_support_final_cto`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                finalCtoStatus === "1"
                  ? "Ticket has been accepted."
                  : "Ticket has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const handleCtoReject = (e) => {
    const validationErrors = ctoValidate();

    setCtoErrors(validationErrors);
    if (ctoNote !== "") setCtoStatus("2");
  };
  const ctoValidate = () => {
    const newErrors = {};
    if (!ctoNote) {
      newErrors.ctoNote = "Note is required";
    }
    return newErrors;
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (ctoStatus === "1" || ctoStatus === "2") {
      if (ctoStatus === "1") {
        sendCtoStatus("accept");
      } else if (ctoStatus === "2") {
        sendCtoStatus("reject");
      }
    }
  }, [ctoStatus]);

  const sendCtoStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (ctoStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", ctoStatus);
      bodyFormData.append("remarks", ctoNote);
      bodyFormData.append(
        "alloted_qc_ttm",
        ctoStatus === "2" ? "" : formData.technicalMember
      );

      utils
        .callAPI("post", `/sales/ticket_support_cto`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                ctoStatus === "1"
                  ? "Ticket has been accepted."
                  : "Ticket has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const techValidate = () => {
    const newErrors = {};

    if (
      formData.technicalMember === "" ||
      formData.technicalMember === undefined
    ) {
      newErrors.techNote = "Technical Member is required";
    }
    return newErrors;
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (storeStatus === "1" || storeStatus === "2") {
      if (storeStatus === "1") {
        sendStoreStatus("accept");
      } else if (storeStatus === "2") {
        sendStoreStatus("reject");
      }
    }
  }, [storeStatus]);

  const handleStoreReject = (e) => {
    const validationErrors = storeValidate();
    setStoreErrors(validationErrors);
    if (storeNote !== "") setStoreStatus("2");
  };
  const storeValidate = () => {
    const newErrors = {};
    if (!storeNote) {
      newErrors.storeNote = "Note is required";
    }
    return newErrors;
  };

  const sendStoreStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (storeStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", storeStatus);
      bodyFormData.append("remarks", storeNote);
      bodyFormData.append(
        "technical_team_member",
        storeStatus === "2" ? "" : formData.technicalMember
      );

      utils
        .callAPI("post", `/sales/ticket_support_rm`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                storeStatus === "1"
                  ? "Ticket has been accepted."
                  : "Ticket has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const handleAttachment = () => {
    if (
      !ttmNote.trim() &&
      (formData.files?.length === 0 || formData.files === undefined)
    ) {
      setAttachErrors(
        "Please provide a note or attach a file before submitting."
      );
      return;
    }

    var bodyFormData = new FormData();
    formData.files?.map((x) => bodyFormData.append("document[]", x));

    bodyFormData.append("id", props?.rowData?.id);
    bodyFormData.append("notes", ttmNote);
    utils
      .callAPI("post", `/sales/save_conclusion_remarks`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          // setTypeCode(res);

          const propdata = {
            mode: "list",
          };
          props.onChange(propdata);
        } else {
          // setTypeCode([]);
        }
      })
      .catch((err) => {
        // setTypeCode([]);
      });
  };

  const handleCeoSubmit = () => {
    // Check if ceoNote is empty or invalid
    if (!ceoNote.trim()) {
      // If empty, set error and return
      setCeoErrors((prevErrors) => ({
        ...prevErrors,
        ceoNote: "Note is required.", // Show error message
      }));
      return; // Stop further execution
    } else {
      // If valid, clear the error
      setCeoErrors((prevErrors) => ({
        ...prevErrors,
        ceoNote: "", // Clear error
      }));
    }

    var bodyFormData = new FormData();
    bodyFormData.append("id", props?.rowData?.id);
    bodyFormData.append("remarks", ceoNote);

    utils
      .callAPI("post", `/sales/ticket_support_ceo_cfo`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          const propdata = {
            mode: "list",
          };
          props.onChange(propdata);
          // Handle the successful response
          // e.g., show success message or do something else
        } else {
          // Handle the case where response is undefined
        }
      })
      .catch((err) => {
        // Handle error in API call
      });
  };

  const handleOpen = (attachment) => {
    // Open the attachment in a new tab
    window.open(attachment, "_blank");
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>
            {isEdit ? `Edit ` : `Request raised for Technical Service Support`}
          </h4>
          <div className="card-header-View">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Card>
              <RB.CardHeader>
                <h6 className={"mb-0"}>Sales Person Detail</h6>
              </RB.CardHeader>
              <RB.CardBody>
                <RB.Row>
                  <RB.Col md={6} className="mb-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Sales Person Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {formData.salePersonName}
                    </p>
                  </RB.Col>
                  <RB.Col md={6} className="mb-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Designation
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {formData.designation}
                    </p>
                  </RB.Col>
                </RB.Row>

                <RB.Row>
                  <RB.Col md={6} className="mb-3">
                    <RB.Row>
                      <RB.Col md={12} className="mb-3">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Location
                        </span>
                        <p className="fw-medium text-sm fw-semibold">
                          {formData.location}
                        </p>
                      </RB.Col>
                      <RB.Col md={12} className="mb-3">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          State
                        </span>
                        <p className="fw-medium text-sm fw-semibold">
                          {formData.state}
                        </p>
                      </RB.Col>
                    </RB.Row>
                  </RB.Col>
                  <RB.Col md={6} className="mb-3">
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Site Details
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {formData.siteDetail}
                    </p>
                  </RB.Col>
                </RB.Row>
              </RB.CardBody>
            </RB.Card>
            <RB.Card>
              <RB.Card.Header
                className={"justify-content-between align-items-center"}
              >
                <h6 className={"mb-0"}>Request for technical service</h6>

                {isTechnicalServiceSelected && (
                  <div className="text-danger">
                    Please select at least one technical support.
                  </div>
                )}
              </RB.Card.Header>
              {/*<label className={"font-weight-600"}>Request for technical service</label>*/}
              <RB.Table
                className={"mb-0"}
                size={"sm"}
                responsive={true}
                bordered={true}
              >
                <thead>
                  <tr>
                    <th
                      valign={"middle"}
                      className={"text-center"}
                      style={{ width: "5%" }}
                    >
                      Sr.No.
                    </th>
                    <th style={{ width: "40%" }}>Service</th>

                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {technicalServices
                    .filter((service) => service.detail !== "")
                    .map((service, index) => (
                      <tr key={index}>
                        <td valign={"middle"} className={"text-center"}>
                          {index + 1}
                        </td>
                        <td valign={"middle"}>{service.title}</td>
                        <td>{service.detail}</td>
                      </tr>
                    ))}
                </tbody>
              </RB.Table>
            </RB.Card>

            <RB.Card>
              {/*<RB.CardHeader><h6 className={"mb-0"}>Products</h6> </RB.CardHeader>*/}
              <RB.CardBody>
                <RB.Row className={"mb-3 row-cols-2"}>
                  <RB.Col>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Products
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {/* Map over the products array, extract the name, and join with commas */}
                      {formData.products
                        .map((product) => product.name)
                        .join(", ")}
                    </p>
                  </RB.Col>
                  <RB.Col>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Expected / Required visit date
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {formData.visitDate}
                    </p>
                  </RB.Col>
                </RB.Row>
              </RB.CardBody>
            </RB.Card>

            {props?.rowData?.allotec_attachment.length > 0 && (
              <div>
                <h6 className="mt-4">Attachments</h6>
                <hr className="hr-lg mt-1" />
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  {props?.rowData?.allotec_attachment.map(
                    (attachment, index) => (
                      <li key={index} style={{ marginBottom: "10px" }}>
                        <a
                          href={attachment}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "blue", textDecoration: "none" }}
                        >
                          Attachment {index + 1}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}

            {props?.rowData?.comments?.length > 0 ? (
              <>
                <h6 className="mt-4">Comments</h6>
                <hr className="hr-lg mt-1" />
                <RB.Table
                  responsive
                  bordered
                  hover
                  striped
                  className="table-responsive "
                >
                  <thead>
                    <tr>
                      <th style={{ width: "5%" }}>Sr</th>
                      <th style={{ width: "35%" }}>Comment</th>
                      <th style={{ width: "25%" }}>Name</th>
                      <th style={{ width: "20%" }}>Role</th>
                      <th style={{ width: "20%" }}>Status</th>
                      <th style={{ width: "15%" }}>Commented Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.rowData?.comments?.map((comment, index) => (
                      <tr key={comment.id}>
                        <td style={{ width: "5%" }}>{index + 1}</td>
                        <td style={{ width: "35%" }}>{comment.comment}</td>
                        <td style={{ width: "25%" }}>
                          {comment.commenter_name}
                        </td>
                        <td style={{ width: "20%" }}>
                          {comment.commenter_role}
                        </td>
                        <td style={{ width: "20%" }}>
                          {comment.commenter_status}
                        </td>
                        <td style={{ width: "15%" }}>
                          {moment(comment.createdAt).format(
                            "DD-MM-YYYY HH:mm:ss A"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </RB.Table>
              </>
            ) : (
              ""
            )}

            {props.rowData.reporting_manager
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData.reporting_manager_status === null && (
                <>
                  <h6>Note</h6>
                  <hr className="hr-lg mt-1" />

                  <RB.Row>
                    <RB.Col md={6}>
                      <div className="mb-3">
                        <RB.FloatingLabel
                          label="Technical Member"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="select"
                            name="technicalMember"
                            value={formData.technicalMember}
                            onChange={handleInputChange}
                            required
                            isInvalid={!!technicalErrors.techNote}
                          >
                            <option value="">Select Technical Member...</option>
                            {role?.map((roleItem) => (
                              <option key={roleItem.id} value={roleItem.id}>
                                {roleItem.firstName + " " + roleItem.lastName}
                              </option>
                            ))}
                          </RB.Form.Control>
                          <RB.Form.Control.Feedback type="invalid">
                            {technicalErrors.techNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>

                    <RB.Col md={6} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="storeNote"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="storeNote"
                            value={storeNote}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!storeErrors.storeNote}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {storeErrors.storeNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>
                  <div>
                    {
                      <>
                        <RB.Button
                          className="me-2"
                          style={{ backgroundColor: "#37c830", color: "white" }}
                          onClick={handleStoreAccept}
                          disabled={loadingAccept} // Disable button while loading
                        >
                          {loadingAccept ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Accept"
                          )}
                        </RB.Button>
                        <RB.Button
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={handleStoreReject}
                          disabled={loadingReject} // Disable button while loading
                        >
                          {loadingReject ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Reject"
                          )}
                        </RB.Button>
                      </>
                    }
                  </div>
                </>
              )}

            {props.rowData.rsm_id
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData.rsm_status === null && (
                <>
                  <h6>Note</h6>
                  <hr className="hr-lg mt-1" />

                  <RB.Row>
                    <RB.Col md={6} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="storeNote"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="rsmNote"
                            value={rsmNote}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!rsmErrors.rsmNote}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {rsmErrors.rsmNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>
                  <div>
                    {
                      <>
                        <RB.Button
                          className="me-2"
                          style={{ backgroundColor: "#37c830", color: "white" }}
                          onClick={handleRsmAccept}
                          disabled={loadingAccept} // Disable button while loading
                        >
                          {loadingAccept ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Accept"
                          )}
                        </RB.Button>
                        <RB.Button
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={handleRsmReject}
                          disabled={loadingReject} // Disable button while loading
                        >
                          {loadingReject ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Reject"
                          )}
                        </RB.Button>
                      </>
                    }
                  </div>
                </>
              )}

            {props.rowData.cto_id
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData.cto_status === null && (
                <>
                  <h6>Note</h6>
                  <hr className="hr-lg mt-1" />
                  <RB.Row>
                    <RB.Col md={6}>
                      <div className="mb-3">
                        <RB.FloatingLabel
                          label="Technical Member"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="select"
                            name="technicalMember"
                            value={formData.technicalMember}
                            onChange={handleInputChange}
                            required
                            isInvalid={!!technicalErrors.techNote}
                          >
                            <option value="">Select Technical Member...</option>
                            {role?.map((roleItem) => (
                              <option key={roleItem.id} value={roleItem.id}>
                                {roleItem.firstName + " " + roleItem.lastName}
                              </option>
                            ))}
                          </RB.Form.Control>
                          <RB.Form.Control.Feedback type="invalid">
                            {technicalErrors.techNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>

                    <RB.Col md={6} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="ctoNote"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="ctoNote"
                            value={ctoNote}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!ctoErrors.ctoNote}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {ctoErrors.ctoNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>
                  <div>
                    {
                      <>
                        <RB.Button
                          className="me-2"
                          style={{ backgroundColor: "#37c830", color: "white" }}
                          onClick={handleCtoAccept}
                          disabled={loadingAccept} // Disable button while loading
                        >
                          {loadingAccept ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Accept"
                          )}
                        </RB.Button>
                        <RB.Button
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={handleCtoReject}
                          disabled={loadingReject} // Disable button while loading
                        >
                          {loadingReject ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Reject"
                          )}
                        </RB.Button>
                      </>
                    }
                  </div>
                </>
              )}

            {props.rowData.alloted_qc_ttm
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData?.cto_status === "1" &&
              (props.rowData.alloted_notes === null ||
                props.rowData.allotec_attachment === []) && (
                <RB.Row>
                  <RB.Col md={12}>
                    <RB.Row>
                      <RB.Col md={6}>
                        <span className="mb-1 small fw-bold ">Attachment</span>
                      </RB.Col>

                      <RB.Col md={6} className={"text-end"}>
                        {attachErrors && (
                          <span style={{ color: "red" }}>{attachErrors}</span>
                        )}
                      </RB.Col>
                    </RB.Row>
                    <hr />
                    <RB.Row className="mt-3 g-3 mb-3">
                      {formData.files !== [] &&
                        (formData?.files || []).map((file, index) => (
                          <RB.Col className="col-md-6 col-lg-4" key={index}>
                            <div className="position-relative mb-4">
                              <div className="document-image">
                                {file.type.startsWith("image/") ? (
                                  <img
                                    src={
                                      typeof file === "string"
                                        ? file
                                        : URL.createObjectURL(file)
                                    }
                                    alt={`File ${index + 1}`}
                                    className="img-fluid"
                                  />
                                ) : (
                                  <div className="file-name">
                                    <i className="las la-file-alt"></i>
                                    <p>{file.name}</p>
                                  </div>
                                )}
                              </div>
                              <RB.Button
                                variant="danger"
                                className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                                onClick={() => handleDeleteFile(index)}
                              >
                                <i className="material-icons-outlined">
                                  delete
                                </i>
                              </RB.Button>
                            </div>
                          </RB.Col>
                        ))}

                      <RB.Col className="col-md-6 col-lg-4">
                        <div
                          className={`border p-4 text-center d-flex flex-column align-items-center ${
                            isDraggingOver ? "bg-info" : ""
                          }`}
                          onDragOver={handleDragOver}
                          onDragEnter={handleDragEnter}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                            <i className="material-icons-outlined">
                              cloud_upload
                            </i>
                          </div>
                          <p className="mb-0">Drag & Drop your files here</p>
                          <small className="mb-2">or</small>
                          <div>
                            <input
                              type="file"
                              multiple
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.txt,.csv,.zip"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                              id="fileInput"
                            />
                            <RB.Button
                              variant="primary"
                              className="me-2"
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              }
                            >
                              <i className="las la-file-upload me-1"></i>Browse
                              Files
                            </RB.Button>
                          </div>
                        </div>
                        <span
                          className={`${!isValidFile ? "text-danger" : ""}`}
                        >
                          <small>
                            *Note: All file types are allowed (images, PDFs,
                            documents, etc.)
                          </small>
                        </span>
                      </RB.Col>
                    </RB.Row>
                  </RB.Col>

                  <RB.Col md={6} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        controlId="ttmNote"
                        className="floating-label-fancy"
                        label="Note"
                      >
                        <RB.Form.Control
                          as="textarea"
                          type="text"
                          placeholder="Enter your note here"
                          name="ttmNote"
                          value={ttmNote}
                          onChange={handleStoreInputChange}
                          maxLength={500}
                          isInvalid={!!ttmErrors.ttmNote}
                          // required={status !== "1"}
                        />
                        <RB.Form.Control.Feedback type="invalid">
                          {ttmErrors.ttmNote}
                        </RB.Form.Control.Feedback>
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Row className="align-items-center mt-3">
                    <RB.Col className="col-auto">
                      <RB.Button variant="primary" onClick={handleAttachment}>
                        Submit
                      </RB.Button>
                    </RB.Col>
                  </RB.Row>
                </RB.Row>
              )}

            {props.rowData.cto_qc_id
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData.cto_qc_status === null && (
                <>
                  <h6>Note</h6>
                  <hr className="hr-lg mt-1" />
                  <RB.Row>
                    <RB.Col md={6} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="finalCtoNote"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="finalCtoNote"
                            value={finalCtoNote}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!finalCtoErrors.finalCtoNote}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {finalCtoErrors.finalCtoNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>
                  <div>
                    {
                      <>
                        <RB.Button
                          className="me-2"
                          style={{ backgroundColor: "#37c830", color: "white" }}
                          onClick={handleFinalCtoAccept}
                          disabled={loadingAccept} // Disable button while loading
                        >
                          {loadingAccept ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Accept"
                          )}
                        </RB.Button>
                        <RB.Button
                          style={{ backgroundColor: "red", color: "white" }}
                          onClick={handleFinalCtoReject}
                          disabled={loadingReject} // Disable button while loading
                        >
                          {loadingReject ? (
                            <RB.Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Close"
                          )}
                        </RB.Button>
                      </>
                    }
                  </div>
                </>
              )}

            {props.rowData?.cfo_ceo_id
              ?.split(",")
              .includes(userProfile.employeeId) &&
              props.rowData.cfo_ceo_status === null && (
                <>
                  <h6>Note</h6>
                  <hr className="hr-lg mt-1" />
                  <RB.Row>
                    <RB.Col md={6} className="no-validation-icon">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          controlId="ceoNote"
                          className="floating-label-fancy"
                          label="Note"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter your note here"
                            name="ceoNote"
                            value={ceoNote}
                            onChange={handleStoreInputChange}
                            maxLength={500}
                            isInvalid={!!ceoErrors.ceoNote}
                            // required={status !== "1"}
                          />
                          <RB.Form.Control.Feedback type="invalid">
                            {ceoErrors.ceoNote}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>
                  </RB.Row>

                  <RB.Row className="align-items-center mt-3">
                    <RB.Col className="col-auto">
                      <RB.Button variant="primary" onClick={handleCeoSubmit}>
                        Close
                      </RB.Button>
                    </RB.Col>
                  </RB.Row>
                </>
              )}
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
